import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ExceptionRequest } from '../../Models/exceptionRequest';
import { ExceptionRequestCotizacion } from '../../Models/exceptionRequestCotizacion';
import { bodyException, ExceptionResponse } from '../../Models/exceptionResponse';
import { UtmHandlerService } from '../../shared/services/utm-handler.service';
import { LeadsService } from '../Leads/leads.service';
import { UtilsService } from './../utils.service';

@Injectable({
  providedIn: 'root',
})
export class ExceptionService {
  baseUri = environment.URL_MULESOFT_EXCEPTION;
  utmHandlerService = inject(UtmHandlerService);

  _body = {};

  envio: ExceptionRequest = {
    percentege_lead: '',
    required_status: '',
  };

  constructor(
    private http: HttpClient,
    private ls: LeadsService,
    private util: UtilsService,
  ) {}

  private createBody(dataLead: ExceptionRequestCotizacion): ExceptionRequestCotizacion {
    return {
      ...dataLead,
      Set_utm_campaign: this.utmHandlerService.getUtmParams()['utm_campaign'] || '',
      Set_utm_content: this.utmHandlerService.getUtmParams()['utm_content'] || '',
      Set_utm_medium: this.utmHandlerService.getUtmParams()['utm_medium'] || '',
      Set_utm_source: this.utmHandlerService.getUtmParams()['utm_source'] || '',
    };
  }

  public addExceptionCotizacion(
    sessionId: string,
    exceptionEnvio: ExceptionRequestCotizacion,
  ): Observable<ExceptionResponse> {
    const headers = this.util.getHeaders(sessionId);
    const finalBody = this.createBody(exceptionEnvio);

    return this.http.post<ExceptionResponse>(this.baseUri, finalBody, {
      headers: headers,
    });
  }

  public addException(
    sessionId: string,
    idLead: string,
    envio: ExceptionRequest,
  ): Observable<ExceptionResponse> {
    const headers = this.util.getHeaders(sessionId);
    const data = JSON.stringify(envio);
    this._body = JSON.parse(data);
    return this.http.post<ExceptionResponse>(
      this.baseUri.concat('?lead_id=').concat(idLead),
      this._body,
      { headers: headers },
    );
  }

  public addExceptionNew(
    sessionId: string,
    leadId: string,
    vrequired_status: string,
    vpercentege_lead: number,
    vestadoRescate?: 'Habilitado' | 'Inhabilitado',
    additionalData?: Partial<bodyException>,
  ): Observable<ExceptionResponse> {
    const body: bodyException = {
      required_status: vrequired_status,
      percentege_lead: vpercentege_lead,
      estadoRescate: vestadoRescate,
      ...additionalData,
    };

    const headers = this.util.getHeaders(sessionId);
    const url = this.baseUri.concat('?lead_id=').concat(leadId);
    return this.http.post<ExceptionResponse>(url, body, { headers });
  }

  public sendGeneralException(
    sessionId: string,
    leadId: string,
    exceptionData: bodyException,
  ): Observable<ExceptionResponse> {
    const headers = this.util.getHeaders(sessionId);

    // Solo agregar lead_id a la URL si existe (no está vacío)
    // Esto permite que la primera pantalla (Cotizador) no envíe lead_id
    const url = leadId ? this.baseUri.concat('?lead_id=').concat(leadId) : this.baseUri;

    console.log(`🌐 URL de excepción: ${url}`);

    return this.http.post<ExceptionResponse>(url, exceptionData, { headers });
  }
}
